import { useEffect, useState } from 'react';

import { useUser } from '@common/hooks/useUser';
import { useRedline } from '@libs/redline';

import useAuthenticatedUser from '@libs/acp/hooks/useAuthenticatedUser';

export const useUpdateEmailModal = () => {
  const { id, document, email, emailStatus } = useUser();
  const { track: trackRedline } = useRedline();

	const { updateACPUSerContactStatus, updateACPCustomer } = useAuthenticatedUser();

  const { neverEngaged } = (emailStatus as any) || {};
  const isNeverEngaged = !!neverEngaged;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showEmailAlert, setShowEmailAlert] = useState(false);
  const [updatedEmail, setUpdatedEmail] = useState<string | null>(null);

  useEffect(() => {
    if (!isModalOpen) return;

    trackRedline.userTracking.elementViewed({
      elementType: 'modal',
      name: 'email-update-modal-checkout-view',
      text: 'Visualizou o modal de atualização cadastral (Never Engaged)',
      location: window.location.pathname,
    });
  }, [isModalOpen, trackRedline]);

  useEffect(() => {
    if (!isNeverEngaged) return;

    const timer = setTimeout(() => {
      setIsModalOpen(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, [isNeverEngaged]);

	const handleEmailUpdate = (newEmail: string) => {
		const oldEmail = email;

		trackRedline.userAuthentication.userAttributeUpdated({
			devedorId: id,
			customer_id: document,
			customer_email: oldEmail,
			key: "email",
			newValue: newEmail,
			oldValue: oldEmail,
		});

		setUpdatedEmail(newEmail);

		const newEmailStatus = {
        neverEngaged: false,
        bounced: emailStatus?.bounced ?? false,
        unsub: emailStatus?.unsub ?? false,
        blocked: emailStatus?.blocked ?? false,
        customer_engagement_status: '',
				expires: Date.now() + 60 * 60 * 1000, // +1 hour
      };

		updateACPUSerContactStatus("email", newEmailStatus);
		updateACPCustomer({ email: newEmail });
	};

  const handleModalOpen = () => {
    setIsModalOpen(true);

    trackRedline.userTracking.elementClicked({
      elementType: 'button',
      name: 'email-update-modal-checkout-open',
      text: 'Abriu o modal de atualização cadastral (Never Engaged)',
      location: window.location.pathname,
    });
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setShowEmailAlert(true);

		trackRedline.userTracking.elementClicked({
      elementType: 'button/icon',
      name: 'email-update-modal-checkout-close',
      text: 'Fechou o modal de atualização cadastral (Never Engaged)',
      location: window.location.pathname,
    });
  };

  return {
    email,
    isNeverEngaged,
    isModalOpen,
    showEmailAlert,
    updatedEmail,
    handleEmailUpdate,
    handleModalOpen,
    handleModalClose,
  };
};
